import React from "react";
import Helmet from "react-helmet";
import UserInfo from "../components/UserInfo/UserInfo";
import PostTags from "../components/PostTags/PostTags";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import "./b16-tomorrow-dark.css";
import "./post.css";
import Jumbotron from "../components/Jumbotron/Jumbotron";

export default class PostTemplate extends React.Component {
  render() {
    const { slug } = this.props.pathContext;
    const postNode = this.props.data.markdownRemark;
    const post = postNode.frontmatter;
    if (!post.id) {
      post.id = slug;
    }
    if (!post.category_id) {
      post.category_id = config.postDefaultCategoryID;
    }
    return (
      <div className="Post">
        <Helmet>
          <title>{`${post.title} | ${config.siteTitle}`}</title>
        </Helmet>
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Jumbotron message={post.title} subhead={post.date} />
        <div className="Post__Content Container">
          <div className="Post__Body">
            <div dangerouslySetInnerHTML={{ __html: postNode.html }} />
          </div>
          <UserInfo config={config} />
          <PostTags tags={post.tags} />
          <SocialLinks postPath={slug} postNode={postNode} />
        </div>
        <style dangerouslySetInnerHTML={{
          __html: `
            .Post .Jumbotron__Background {
              background-image: linear-gradient(to bottom left, #00a2ff8c, #5e0052), url('${post.cover}');
              background-position: ${post.position};
            }
        `}} />
      </div>
    );
  }
}

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        cover
        date(formatString: "MMMM DD, YYYY")
        category
        tags
        position
      }
      fields {
        slug
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.jsx